import { EZModule } from '../../classes/v2/EZModule';
import { Strings } from '../../libs/Strings';
import { modules } from '../../main';
import Handlebars from 'handlebars';
import {CaspardoAPI} from '../../classes/api/CaspardoAPI';
var debounce = require('lodash.debounce');

declare let currentPageSite: string;
declare let ezentrum_session_vars: any;

export default class Autocomplete extends EZModule {

    private static yaml: { config: {
        preventEmptySearch: boolean;
        closeSearchOutput: boolean;
        specialHandlingFor: string;
        wpKeys: string;
        includeWP: any;
        wpURL: string;
        target_url: any; search_url: string; setBodyFixed: any; autocomplete_build_order: string[]; search_autocomplete: any; isCloudPicture: boolean; avif_tag: string; webp_tag: string; jpg_tag: string; article_limiter: number; brand_blacklist: any; autocomplete_viewtype: string; 
}; components: {
    foundation: {
        noContentFound: string;
        closeButton: string;
        wpSetup: string; search_url: string; products: string; brands: string; categories: string; keywords: string; recommendations: string; contents: string; 
}; }; labels: { [x: string]: { [x: string]: string; }; }; } ; // yaml data
    private static content_data:any; // json data
    private static searchInputField: NodeListOf<HTMLInputElement>; // the search input field(s)
    private static searchOutputElement: HTMLDivElement;
    private static languageID:string; // the language ID from the yaml
    private static language_prefix:string; // de || en || fr || es
    private static targetURL: string; // target url for the search 'Search for {{qurey}}'
    private static timer: NodeJS.Timeout; // used for the timeout/ reset timeout function

    private hasBeenTypedIn: boolean;
    private UUID: string;
    private mandant_id:string;
    private abortController: AbortController;

    /** @param configuration = part of the yaml with Autocomplete */
    public constructor(configuration:any ) {
        super(configuration);
        Autocomplete.yaml = configuration;
        this.hasBeenTypedIn = false;
        this.UUID = '';
    }

    public init():void {
        // starter pack for the search url
        Autocomplete.languageID = modules.getGlobalConfig( 'livesuche_language_mapping.' + modules.getLanguageCode()); // currently used language's id
        Autocomplete.language_prefix = modules.getLanguageCode(); // on purpose not simply inside the Autocomplete.target_URL
        Autocomplete.targetURL = `${Autocomplete.yaml.config.target_url}&hid=${modules.getGlobalConfig('mandant_id')}&sprachnr=${Autocomplete.language_prefix}&enter=livesuche&query=`;
        Autocomplete.searchOutputElement = document.getElementById('search_output') as HTMLDivElement;
        this.abortController = new AbortController();
        this.mandant_id = modules.getGlobalConfig('mandant_id');
        this.checkCurrentSite();
        this.assignEvents();
        this.checkDeleteButton();
        this.preventEmptySearch();
    }

    /** @description assigning EventListenerEvents */
    private assignEvents():void {
        Autocomplete.searchInputField = document.querySelectorAll('[data-ez-search-input]'); // getting all the search input fields
        if (typeof ezentrum_session_vars !== 'undefined') {
            if (typeof Autocomplete.searchInputField !== 'undefined') {
                Autocomplete.searchInputField.forEach(inputField => { inputField.value = ezentrum_session_vars.livesuche.query;});
            }
        }
        let counter:number = 0;
        // setting each input fields up with a placeholder and an eventListerner for inputs
        if (typeof Autocomplete.searchInputField !== 'undefined') {
            Autocomplete.searchInputField.forEach(async inputField => {
                inputField.placeholder = this.returnLabel('input_placeholder'); // placeholder
                const debounceAutocomplete = debounce(async (inputField:any) => {
                    try {
                        this.showWaitingAnimation();
                        const inputString = inputField.value;
                        this.abortFetch(this.abortController);

                        this.abortController = new AbortController();
                        const signal = this.abortController.signal;

                        Autocomplete.content_data = await CaspardoAPI.getSuggestions(
                            Autocomplete.yaml.config.search_url,
                            Autocomplete.languageID,
                            inputString,
                            this.UUID,
                            this.mandant_id,
                            signal
                        );
                        this.fillInformationIn(Autocomplete.content_data.autocomplete, inputField);
                    }
                    catch(err) {
                        console.log(err);
                    }
                    finally {
                        this.hideWaitingAnimation();
                    }
                }, 500);
                inputField.addEventListener('input', ()=> {
                    debounceAutocomplete(inputField);
                });

                if (inputField.value !== "" && counter === 0) { // counter makes sure we only do this once even there might be multiple inputFields
                    counter++;
                    let inputString:string = inputField.value; // getting the currently placed signs from the input field
                    this.abortFetch(this.abortController); // might be not needed here

                    this.abortController = new AbortController();
                    const signal = this.abortController.signal;
                    Autocomplete.content_data = await CaspardoAPI.getSuggestions(Autocomplete.yaml.config.search_url,Autocomplete.languageID,inputString, this.UUID, this.mandant_id, {signal}); // waiting to retrieve the json data
                    this.fillInformationIn( Autocomplete.content_data.autocomplete, inputField );
                    Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'false');
                }
            });
        }

        const htmlBodyElement:HTMLBodyElement = document.getElementsByTagName('body')[0]; // getting _the_ body element
        // visibility event for touch and click
        document.addEventListener('pointerdown', (event:any)=> {
            let target:HTMLElement = event.target; // clicked or touched html element
            // TODO: Define exact HTML structure, to make this work as intended, else rewrite the next line with the most outter element of the input fields container
            let branch:HTMLElement = target.closest('#form_search'); // child element or the most outter element of the input fields clickable area itself

            const closeSearchOutputEle: HTMLElement = document.getElementById('ezCloseSearchOutput') as HTMLElement;
            if ( closeSearchOutputEle && event.target.closest('#ezCloseSearchOutput') === closeSearchOutputEle) {
                branch = null;
            }

            if (branch !== null) { // child element or itself is the target
                // leaving the function if the target is the search/exit button of the slider area (only in sup-way so far)
                if (target.id === 'ez_slide_search_button' || target.id === "ez_slide_search_cancel_button") { return;}
                Autocomplete.searchInputField.forEach( inputField => { // looking through the input fields
                    if (inputField.value === "") { return; }// if they are empty leave the function
                    Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'true'); // open the output area
                });
                if (Autocomplete.yaml.config.setBodyFixed) {
                    htmlBodyElement.style.position = 'fixed'; // prevents scrolling on other than the output element
                }
            }
            // else path means the element or its childs haven't been the target element
            else {
                // closing the output element and resetting the html body
                if (Autocomplete.searchOutputElement && Autocomplete.searchOutputElement.getAttribute('data-ez-open') === 'true') {
                    Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'false');
                    if (Autocomplete.yaml.config.setBodyFixed) {
                        htmlBodyElement.style.position = 'initial';
                    }
                }
                else if (target.closest('#search_logo') !== null) {
                    Autocomplete.searchInputField.forEach( inputField => {  // looking through the input fields
                        if (inputField.value === "") { return; }    // if they are empty leave the function
                        Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'true');  // open the output area
                    });
                    if (Autocomplete.yaml.config.setBodyFixed) {
                        htmlBodyElement.style.position = 'fixed';   // prevents scrolling on other than the output element
                    }
                }
            }
        });
    }

    /** @Chris
     * @description The end result is the search output which gets displayed
     * @param content_data = json information about the search results
     * @param usedInputField = the input field where the user has written in
     */
    private async fillInformationIn(content_data:any, usedInputField:HTMLInputElement):Promise<void> {
        Autocomplete.searchOutputElement.innerHTML = '';
        if ( !this.hasBeenTypedIn ) {
            this.hasBeenTypedIn = true;

            const url = window.location.href;
            // Create a URLSearchParams object from the URL
            const urlParams = new URLSearchParams(url);

            // Get the value of the 'uuid' parameter
            const uuidValue = urlParams.get('uuid');

            if ( uuidValue ) { this.UUID = uuidValue; }
            else { this.UUID = Autocomplete.content_data.uuid; }

            const UUIDField: HTMLInputElement = document.getElementById('ez_UUID') as HTMLInputElement;
            if ( UUIDField ) UUIDField.value = this.UUID;
        }
        if ( usedInputField.value === "" ) {
            Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'false');
            if (Autocomplete.yaml.config.setBodyFixed) {
                const htmlBodyElement:HTMLBodyElement = document.getElementsByTagName('body')[0]; // getting _the_ body element
                htmlBodyElement.style.position = 'initial';   // prevents scrolling on other than the output element
            }
            return;
        }

        /** livesuche Search Information pallete */
        let search_url:Object = `${Autocomplete.targetURL}${content_data.searchword}&uuid=${this.UUID}`; // yaml conf 'search_url'
        let products:any = content_data.products; // yaml conf 'products'
        let brands:any = content_data.brand; // yaml conf 'brands'
        let categories:any = content_data.categories; // yaml conf 'categories'
        let keywords:any = content_data.keywords; // yaml conf 'keywords'
        let recommendations:any = content_data.recommendation; // yaml conf 'recommendations'
        let contents:any = content_data.contentall; // yaml conf 'contents'
        /** /livesuche Search Information pallete */

        let content_order:Array<string> = Autocomplete.yaml.config.autocomplete_build_order; // yaml config for the output order
        let search_autocomplete:any = Autocomplete.yaml.config.search_autocomplete; // yaml config for deciding which output gets displayed
        let handlebarsCompileObject:any = {}; // object in which we fill in our upcoming data
        let orderedYamlConfig:string = ''; // the content of the output gets placed inside here, in order.

        // going over the content's order
        content_order.forEach((content:string) => {
            switch (true) {
                case content === 'search_url' && search_autocomplete.build_link === true:
                    if (search_url && content_data.searchword) { // checking the existence and if the searchword is filled, probably redundant
                        handlebarsCompileObject.search =
                        {
                            search_url: search_url,
                            search_value: content_data.searchword,
                            headline: this.returnLabel('query_text'),
                            type: '1',
                            uuid: this.UUID
                        };
                        if (content_data.searchword !== Autocomplete.searchInputField[0].value ) {
                            handlebarsCompileObject.search.searchword =  Autocomplete.searchInputField[0].value;
                            handlebarsCompileObject.search.searchword_url = `${Autocomplete.targetURL}${Autocomplete.searchInputField[0].value}`;
                        };
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.search_url; // placing the search part onto the string template
                    } break;
                case content === 'products' && search_autocomplete.products === true:
                    if (products && products.hits > 0) {
                        products.productnameitem = this.makeObjectArray(products.productnameitem);
                        handlebarsCompileObject.products =
                        {
                            products: products,
                            headline: this.returnLabel('headline_products'),
                            type: '2',
                            article_number: this.returnLabel('article_number'), // label for {{this.article_number}}
                            brand: this.returnLabel('brand'), // label for {{this.article_number}}
                        };
                        handlebarsCompileObject.products.products.productnameitem = this.makeObjectArray(handlebarsCompileObject.products.products.productnameitem);
                        // @Chris
                        // Block: branch when using cloudPictures, taking advantage of cloud pictures, to make the pictures themselfs smaller, more comprimised
                        const isCloudPicture:boolean | null = Autocomplete.yaml.config.isCloudPicture;
                        if ( isCloudPicture !== null && isCloudPicture ) {
                            const avif_tag: string = Autocomplete.yaml.config.avif_tag !== null ? Autocomplete.yaml.config.avif_tag : "";
                            const webp_tag: string = Autocomplete.yaml.config.webp_tag !== null ? Autocomplete.yaml.config.webp_tag : "";
                            const jpg_tag: string = Autocomplete.yaml.config.jpg_tag !== null ? Autocomplete.yaml.config.jpg_tag : "";

                            for ( const productItem of handlebarsCompileObject.products.products.productnameitem ) {
                                const productThumbNailString:string = productItem.productthumbnail;
                                if ( !productThumbNailString.includes('https://ezentrum-res.cloudinary.com') ) continue;
                                const thumbURL:string = productItem.productthumbnail; // standard url that we get from the results
                                const modifiedStartURL: string = '//ezentrum-res.cloudinary.com/image/upload/'; // cloudinary standard start src string
                                const modifiedEndURL = thumbURL.replace('https://ezentrum-res.cloudinary.com/image/upload' , ''); // removing the first part
                                // applying the strings accordingly
                                productItem.avif_tag = `${modifiedStartURL}${avif_tag}${modifiedEndURL.replace('.png', '.avif')}`;
                                productItem.webp_tag = `${modifiedStartURL}${webp_tag}${modifiedEndURL.replace('.png', '.webp')}`;
                                productItem.jpg_tag = `${modifiedStartURL}${jpg_tag}${modifiedEndURL.replace('.png', '.jpg')}`;
                            }
                        }

                        // Block: Config - checking whether there is a limit set for the amount of products to be shown or not
                        if (Autocomplete.yaml.config.article_limiter && Autocomplete.yaml.config.article_limiter < handlebarsCompileObject.products.products.productnameitem.length ) {
                            handlebarsCompileObject.products.products.productnameitem.length = Autocomplete.yaml.config.article_limiter; // does the same as slice, just easier.
                        }
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.products;
                    } break;
                case content === 'brands' && search_autocomplete.brands === true:
                    if ( ( brands && brands.branditem.length > 0) || (brands && brands.branditem.brandname !== '' ) ) {
                        brands.branditem = this.makeObjectArray(brands.branditem);
                        /** @Chris
                         * Block: Removing unwanted brands
                         */
                        const blackList = Autocomplete.yaml.config.brand_blacklist;
                        if ( blackList !== null && blackList !== undefined && blackList.length > 0 ) {
                            blackList.forEach( (blackListItem:any) => {
                                const index = brands.branditem.findIndex((brandItem: { brandname: string; }) => brandItem.brandname === blackListItem);
                                if (index >= 0) {
                                    brands.branditem.splice(index,1);
                                }
                            });
                        }

                        handlebarsCompileObject.brands =
                        {
                            brands: brands,
                            headline: this.returnLabel('headline_brands'),
                            type: '3'
                        };
                        handlebarsCompileObject.brands.brands.branditem = this.makeObjectArray(handlebarsCompileObject.brands.brands.branditem);
                        handlebarsCompileObject.brands.brands.branditem.forEach( (item:any)=> {
                            if (content_data.searchword !== Autocomplete.searchInputField[0].value ) {item.url = this.buildTargetURL(('&brand=' + encodeURIComponent(item.brandname)),('&query=' + encodeURIComponent(Autocomplete.searchInputField[0].value))); }
                            else { item.url = this.buildTargetURL(('&brand=' + encodeURIComponent(item.brandname)),('&query=' + encodeURIComponent(content_data.searchword))); }
                        });
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.brands;
                    } break;
                case content === 'categories' && search_autocomplete.categories === true:
                    if ( categories && categories.category && categories.category.length > 0 || ( categories && categories.category && categories.category.name && categories.category.name !== '')) {
                        categories.category = this.makeObjectArray(categories.category);
                        handlebarsCompileObject.categories =
                        {
                            categories: categories,
                            headline: this.returnLabel('headline_categories'),
                            type: '4'
                        };
                        handlebarsCompileObject.categories.categories.category = this.makeObjectArray(handlebarsCompileObject.categories.categories.category);
                        handlebarsCompileObject.categories.categories.category.forEach( (item:any)=> {
                            if (content_data.searchword !== Autocomplete.searchInputField[0].value ) { item.url = this.buildTargetURL(('&query=' + encodeURIComponent(Autocomplete.searchInputField[0].value)),('&category1=' + encodeURIComponent(item.name ))); }
                            else { item.url = this.buildTargetURL(('&query=' + encodeURIComponent(content_data.searchword)),('&category1=' + encodeURIComponent(item.name ))); }
                        });
                        //  adding categories to the yaml template
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.categories;
                    } break;
                case content === 'keywords' && search_autocomplete.keywords === true:
                    if (keywords.hits === 0) break;
                    if (keywords.keyworditem ) {
                        handlebarsCompileObject.keywords =
                        {
                            keywords: keywords,
                            headline: this.returnLabel('headline_keywords'),
                            type: '5'
                        };
                        handlebarsCompileObject.keywords.keywords.keyworditem = this.makeObjectArray(handlebarsCompileObject.keywords.keywords.keyworditem);
                        handlebarsCompileObject.keywords.keywords.keyworditem.forEach( (item:any)=> {
                            // old livesuche search
                            // item.url = this.buildTargetURL(('&query=' + encodeURIComponent(item.queryword)));

                            // new live search
                            item.url = this.buildTargetURL( ('&query=' + encodeURIComponent(content_data.searchword)), ('&category2=' + encodeURIComponent(item.queryword )) );
                        });
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.keywords;
                    } break;
                case content === 'recommendations' && search_autocomplete.recommendation === true:
                    if (recommendations && recommendations.entry.length > 0) {
                        recommendations.entry = this.makeObjectArray(recommendations.entry);
                        handlebarsCompileObject.recommendations =
                        {
                            recommendations: recommendations,
                            headline: this.returnLabel('headline_recommendations'),
                            type: '6'
                        };
                        handlebarsCompileObject.recommendation.entry = this.makeObjectArray(handlebarsCompileObject.recommendation.entry);
                        handlebarsCompileObject.recommendation.entry.forEach( (item:any)=> {
                            item.url = item.link;
                        });
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.recommendations;
                    } break;
                case content === 'contents' && search_autocomplete.content === true:
                    if (contents && contents.hits > 0) {
                        handlebarsCompileObject.contents =
                        {
                            contents: contents,
                            headline: this.returnLabel('headline_contents'),
                            type: '7'
                        };
                        handlebarsCompileObject.contents.contents.item = this.makeObjectArray(handlebarsCompileObject.contents.contents.item);
                        orderedYamlConfig += Autocomplete.yaml.components.foundation.contents;
                    } break;
            };
        });
        if (typeof handlebarsCompileObject.products !== 'undefined' ) {
            orderedYamlConfig = Strings.replaceMultiple(orderedYamlConfig,"[label:article_number]",handlebarsCompileObject.products.article_number);
            orderedYamlConfig = Strings.replaceMultiple(orderedYamlConfig,"[label:brand]",handlebarsCompileObject.products.brand);
        }
        // Makes the above if useless
        // Collect all the labels of the current language inside the object thats used by handlebars
        const allCurrentLabels:Array<Object> = [Autocomplete.yaml.labels[Autocomplete.language_prefix]];
        const allLabelKeys = Object.keys( allCurrentLabels[0]);
        allCurrentLabels.forEach((dictionary:any) => {
            allLabelKeys.forEach(key => {
                const value = dictionary[key];
                handlebarsCompileObject[key] = value;
            });
        })

        const template:HandlebarsTemplateDelegate<any> = Handlebars.compile(orderedYamlConfig);
        const res:string = template( handlebarsCompileObject);

        const closeSearchOutput: boolean = Autocomplete.yaml.config.closeSearchOutput;
        const closeOutputButton: string = Autocomplete.yaml.components.foundation.closeButton as string;
        const noContentFound:string = Autocomplete.yaml.components.foundation.noContentFound as string;
        // way to add a close button
        if ( closeSearchOutput && closeOutputButton ) {
            const concatString = closeOutputButton + (res !== '' ? res : (noContentFound ? noContentFound : "<h3>Keine passenden Ergebnisse gefunden</h3>"));
            Autocomplete.searchOutputElement.innerHTML = concatString;
        }
        else {
            Autocomplete.searchOutputElement.innerHTML = res !== '' ? res : noContentFound ? noContentFound : "<h3>Keine passenden Ergebnisse gefunden</h3>";  // fill in the content
        }

        Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'true');

        // new setup for WordPress content
        const includeWP:boolean = Autocomplete.yaml.config.includeWP;
        if ( includeWP ) {
            this.abortController = new AbortController();
            const signal = this.abortController.signal;
            await this.includeWordPress(content_data.searchword, signal);
        }
        // kann wirklich nur nachdem alles geladen wird erstellt werden
        this.side_by_sideView();
    }


    /** @Chris
     * @description Getting content from the WordPress pages
     * @param search_word = the entered query
     */
    private async includeWordPress(search_word: string, signal: any): Promise<void> {
        const { wpSetup } = Autocomplete.yaml.components.foundation;
        const { wpURL, specialHandlingFor } = Autocomplete.yaml.config;

        if (!wpSetup || !wpURL)
            throw new Error("Missing required data for WordPress inclusion");

        const langPrefix = Autocomplete.language_prefix;
        const url = wpURL.replace(/{search_word}|{lang}/g, (match:string) => {
            return match === "{search_word}" ? search_word : langPrefix;
        });

        try {
            const getWPContentRes = await fetch(url, { signal });

            if (!getWPContentRes.ok) {
                throw new Error(`Failed to fetch data. Status code: ${getWPContentRes.status}`);
            }

            if (signal && signal.aborted) return;

            const wpJsonData = await getWPContentRes.json();

            switch (specialHandlingFor) {
                case 'R&G': {
                    const pages = wpJsonData.query?.pages;

                    if (!pages || Object.keys(pages).length === 0) {
                        console.log(`No Article found for the query ${search_word}`);
                        return;
                    }

                    const rgJson = Object.values(pages).map((page: any) => ({
                        ...page,
                        link: encodeURIComponent(page.title),
                    }));

                    const template = Handlebars.compile(wpSetup);
                    const res = template(rgJson);
                    Autocomplete.searchOutputElement.innerHTML += res;
                    break;
                }
                case 'NEB_DE': {
                    const postURL = wpURL
                        .replace('pages?', 'posts?')
                        .replace('{search_word}', search_word)
                        .replace('{lang}', langPrefix)
                        .replace('per_page=5', 'per_page=3');

                    try {
                        const getWPContentPostRes = await fetch(postURL, { signal });

                        if (!getWPContentPostRes.ok) {
                            const template = Handlebars.compile(wpSetup);
                            const res = template(wpJsonData);
                            Autocomplete.searchOutputElement.innerHTML += res;
                        } else {
                            if (signal && signal.aborted) return;

                            const postJsonData = await getWPContentPostRes.json();
                            const template = Handlebars.compile(wpSetup);
                            const res = template(wpJsonData);
                            const resPost = template(postJsonData);
                            const newRes = res + resPost;
                            Autocomplete.searchOutputElement.innerHTML += newRes;
                        }
                    } catch (err) {
                        // Handle the error for the post request
                    }
                    break;
                }
                default: {
                    const template = Handlebars.compile(wpSetup);
                    const res = template(wpJsonData);
                    Autocomplete.searchOutputElement.innerHTML += res;
                }
            }
        } catch (err) {
            throw new Error("Failed to fetch the data: " + err.message);
        }
    }

    /**
     * @description get _a_ label
     * @param headline_yaml_part = yaml label key
     * @returns a label with the currently used language (...label[Au...language_prefix] = de || en || fr || es)
    */
    private returnLabel(headline_yaml_part:string):string {
        return Autocomplete.yaml.labels[Autocomplete.language_prefix][headline_yaml_part];
    }

    /**
     * @description Makes anything into an array, used for some objects
     * @param objectArray handlebarsCompileObject from the function fillInformationIn(), more precisely, specific inner objects
     * @returns handlebarsCompileObjects inner object itself or inside the loop the object but inside an array
     */
    private makeObjectArray(objectArray:Object):Array<any> {
        if ( (objectArray instanceof Array) ) return objectArray;
        let tempArr:Array<any> = [];
        tempArr.push( objectArray );
        return objectArray = tempArr;
    }

    /** additional handling if the site is 'livesuche.htm' */
    private checkCurrentSite():void {
        // If NOT currentPageSite has value and is livesuche --> stop
        if (! ( typeof currentPageSite !== 'undefined' && currentPageSite === 'livesuche.htm')) return null;
        Autocomplete.searchInputField = document.querySelectorAll('[data-ez-search-input]'); // getting all the search input fields
        let slideSearchBar:HTMLDivElement = document.getElementById('ez_search_bar_desktop') as HTMLDivElement;
        if (slideSearchBar) slideSearchBar.classList.add('show');
    }

    /** @Chris
     * @description building the URL for their specific target
     * @param end_string !only some URLs have this part!, another string part
     * shorthand if for:
     * if end_string -> longer version (with end_string), else -> short version url (wtihout end_string)
     * @param livesuche_followup_string first string part of the latter parts of the URL
     * @returns the target URL
     */
    private buildTargetURL(livesuche_followup_string:string, end_string?:string):string {
        return end_string
        ?    `${Autocomplete.yaml.config.target_url}&hid=${modules.getGlobalConfig('mandant_id')}&sprachnr=${Autocomplete.language_prefix}&enter=livesuche${livesuche_followup_string}${end_string}&uuid=${this.UUID}`
        :    `${Autocomplete.yaml.config.target_url}&hid=${modules.getGlobalConfig('mandant_id')}&sprachnr=${Autocomplete.language_prefix}&enter=livesuche${livesuche_followup_string}&uuid=${this.UUID}`;
    }

    /** @Chris
     * deleteInputButton, on press resets the search inputs content
     */
    private checkDeleteButton():void {
        const deleteInputButton:HTMLButtonElement = document.getElementById('ez_search_delete') as HTMLButtonElement; // getting the delete button
        if ( !deleteInputButton ) { return console.error("The delete functionality for the autocomplete couldn't be activated"); // if there is no deleteInputButton, return message
        }
        const searchInputElement: HTMLInputElement = document.getElementById('search_input') as HTMLInputElement; // getting the search input element
        deleteInputButton.addEventListener('pointerdown', () => { // adding the event to on touch and on click
            searchInputElement.value = ''; // resetting the search inputs value
            Autocomplete.searchOutputElement.setAttribute('data-ez-open', 'false'); // closing the search results
        });
    }

    /** @Chris
     * @description Using to create a side by side view, instead of simply top to bottom
     * yaml setup: config..autocomplete_viewtype: "side-by-side"
     * html setup:
     *  <div id="ez_autocomplete_left_site"></div>
        <div id="ez_autocomplete_right_site"></div>
     */
    private side_by_sideView():void {
        const autocompleteViewType:string = Autocomplete.yaml.config.autocomplete_viewtype;
        if ( !autocompleteViewType || autocompleteViewType !== 'side-by-side') return;
        const ezAutocompleteLeftSite:HTMLDivElement = document.getElementById('ez_autocomplete_left_site') as HTMLDivElement;
        const ezAutocompleteRightSite:HTMLDivElement = document.getElementById('ez_autocomplete_right_site') as HTMLDivElement;
        if ( !ezAutocompleteRightSite || !ezAutocompleteLeftSite ) return;
        const searchContainerList:NodeListOf<HTMLDivElement> = document.querySelectorAll('.search_container');
        if (searchContainerList.length <= 0 ) return;
        // throwing the elements inside the right html element and deleting the original container
        // not possible if unequal of length
        searchContainerList.forEach( ( searchContainer:HTMLDivElement ) => {
            const headline:HTMLHeadElement = searchContainer.querySelector('.search_headline');
            const searchContent:HTMLDivElement = searchContainer.querySelector('.search_content');
            if (!headline || !searchContent) return;
            ezAutocompleteLeftSite.appendChild(headline);
            ezAutocompleteRightSite.appendChild(searchContent);
            searchContainer.remove();
        });
        this.dynamicHoverDisplay(ezAutocompleteLeftSite, ezAutocompleteRightSite);
    }

    /**
     * @Chris
     * @description Hover event for the left elements, to display the correct content
     * @param leftContainer = html element
     * @param rightContainer = html element
     */
    private dynamicHoverDisplay(leftContainer:HTMLDivElement, rightContainer:HTMLDivElement):void {
        const searchHeadlineList:NodeListOf<HTMLHeadElement> = leftContainer.querySelectorAll('.search_headline'); // getting all elements of the left box
        const contentAreaList:NodeListOf<HTMLDivElement> = rightContainer.querySelectorAll('.search_content'); // getting all elements of the right box
        if (contentAreaList.length <= 0 || searchHeadlineList.length <= 0) return; // stopptin if one of them is emtpy
        contentAreaList[0].classList.add('d-flex'); // displaying the content of the first entry
        // dis- and enabling the correct elements
        leftContainer.addEventListener('mouseover', ( event )=> {
            searchHeadlineList.forEach( ( headerElement:HTMLHeadElement, headlinePos:number) => {
                if (headerElement !== event.target) return;
                contentAreaList[headlinePos].classList.add('d-flex'); // enabling
                searchHeadlineList.forEach( (elements, position )=> { // disabling
                    if ( elements !== event.target && contentAreaList[position].classList.contains('d-flex'))
                        contentAreaList[position].classList.remove('d-flex');
                });
            });
        });
    }

    /** @Chris
     * @description adding class ez_waiting_show for displaying a waiting animation
     */
    private showWaitingAnimation():void {
        const waiting_animation:HTMLDivElement = document.getElementById('ez_waiting_animation') as HTMLDivElement;
        if ( waiting_animation ) waiting_animation.classList.add('ez_waiting_show');
    }

    private hideWaitingAnimation(): void {
        const waiting_animation:HTMLDivElement = document.getElementById('ez_waiting_animation') as HTMLDivElement;
        if ( waiting_animation ) waiting_animation.classList.remove('ez_waiting_show');
    }


    private preventEmptySearch():void| boolean {
        const preventEmptySeach: boolean = Autocomplete.yaml.config.preventEmptySearch;
        if ( !preventEmptySeach || Autocomplete.searchInputField.length <= 0 ) return;
        Autocomplete.searchInputField.forEach( ele => {
            const closestForm: HTMLFormElement = ele.closest('form');
            if ( !closestForm ) return;
            closestForm.addEventListener('submit', (e:Event)=> {
                if ( ele.value.trim() === "" ) {
                    e.preventDefault();
                    return false;
                }
            });
        });
    }

    private abortFetch(controller: { signal: { aborted: any; }; abort: () => void; }):void {
        if (controller && !controller.signal.aborted) {
            controller.abort();
        }
    }

    public run() {} // empty. Kept for compability.
    public getClass(): string { return 'ez-autocomplete'; }/** @returns The class name of the HTML element that houses Autocomplete */
}
